<button mat-stroked-button type="button" routerLink="/log-stream" class="layout-padding">
  <mat-icon>keyboard_arrow_left</mat-icon>
  Back to LogStream List
</button>

<p>log-stream-detail works!</p>
